import { render, staticRenderFns } from "./PortfolioStats.vue?vue&type=template&id=151a49a6"
import script from "./PortfolioStats.vue?vue&type=script&lang=js"
export * from "./PortfolioStats.vue?vue&type=script&lang=js"
import style0 from "./PortfolioStats.vue?vue&type=style&index=0&id=151a49a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports